import { DEFAULT_STATUS_KEY, StatusInfo } from 'src/core/StatusInfo';

export const LoanStatusInfoMap: Record<string, StatusInfo> = {
    PENDING: {
        color: 'var(--pending-color)',
        borderColor: 'var(--pending-border-color)',
        title: 'Pending',
        backgroundColor: 'var(--pending-background)',
    },
    ACTIVE: {
        color: 'var(--active-color)',
        borderColor: 'var(--active-border-color)',
        title: 'Active',
        backgroundColor: 'var(--active-background)',
    },
    REPAID: {
        color: 'var(--repaid-color)',
        borderColor: 'var(--repaid-border-color)',
        title: 'Repaid',
        backgroundColor: 'var(--repaid-background)',
    },
    OVERDUE: {
        color: 'var(--overdue-color)',
        borderColor: 'var(--overdue-border-color)',
        title: 'Overdue',
        backgroundColor: 'var(--overdue-background)',
    },
    WRITTEN_OFF: {
        color: 'var(--writtenOff-color)',
        borderColor: 'var(--writtenOff-border-color)',
        title: 'Written-off',
        backgroundColor: 'var(--writtenOff-background)',
    },
    PROCESSING: {
        color: 'var(--processing-color)',
        borderColor: 'var(--processing-border-color)',
        title: 'Processing',
        backgroundColor: 'var(--processing-background)',
    },
    ERROR: {
        color: 'var(--error-color)',
        borderColor: 'var(--error-border-color)',
        title: 'Error',
        backgroundColor: 'var(--error-background)',
    },
    ADVANCE_CONSENT_EXPIRED: {
        color: 'var(--advanced-expired-color)',
        borderColor: 'var(--advanced-expired-border-color)',
        title: 'Advance consent expired',
        backgroundColor: 'var(--advanced-expired-background)',
    },
    ADVANCE_CONSENT_CONFIRMATION: {
        color: 'var(--advanced-consent-color)',
        borderColor: 'var(--advanced-consent-border-color)',
        title: 'Advance consent confirmation',
        backgroundColor: 'var(--advanced-consent-background)',
    },
    AWAITING_ADVANCE_PAYMENT: {
        color: 'var(--advanced-payment-color)',
        borderColor: 'var(--advanced-payment-border-color)',
        title: 'Dental treatment started',
        backgroundColor: 'var(--advanced-payment-background)',
    },
    DENTAL_TREATMENT_STARTED: {
        color: 'var(--dental-treatment-color)',
        borderColor: 'var(--dental-treatment-border-color)',
        title: 'Advanced consent expired',
        backgroundColor: 'var(--dental-treatment-background)',
    },
    '1ST_STAGE_COMPLETED': {
        color: 'var(--first-stage-color)',
        borderColor: 'var(--first-stage-border-color)',
        title: '1st stage completed',
        backgroundColor: 'var(--first-stage-background)',
    },
    REPAYMENT_CONSENT_CONFIRMATION: {
        color: 'var(--consent-confirmation-color)',
        borderColor: 'var(--consent-confirmation-border-color)',
        title: 'Repayment consent confirmation',
        backgroundColor: 'var(--consent-confirmation-background)',
    },
    REPAYMENT_CONSENT_EXPIRED: {
        color: 'var(--consent-expired-color)',
        borderColor: 'var(--consent-expired-border-color)',
        title: 'Repayment consent expired',
        backgroundColor: 'var(--consent-expired-background)',
    },
    DECLINED: {
        color: 'var(--declined-color)',
        borderColor: 'var(--declined-border-color)',
        title: 'Declined',
        backgroundColor: 'var(--declined-background)',
    },
    [DEFAULT_STATUS_KEY]: {
        color: '#91796c',
        borderColor: '#F4F0DF',
        title: '',
        backgroundColor: '#F4F0DF',
    },
};
